<template>
    <div class="dashboard">
      <div>
        <div>
          <LandingBar active="trading" />
          <div class="buy-map-wrapper">
            <!-- <div class="lottie-wrapper" v-if="!map">
              <lottie :options="defaultOptions" :height="400" :width="500" />
              <div class="loading-text">Loading...</div>
            </div> -->
            <div class="buy-map-inner-wrapper">
              <Auto
                :map="map"
                :currentMatching="currentMatching"
                :currentIndex="currentIndex"
                :allMatchings="allMatchings"
                @goToBuy="goToBuy"
                @setCurrentMatching="(match) => setCurrentMatching(match)"
                @setCurrentIndex="(index) => setCurrentIndex(index)"
                @zoom="(point) => zoomToPoint(point)"
                @change="changeLayer"
                @wind="changeWind"
                @load="changeLoad"
                @ev="changeEV"
                @country="changeCountry"
                @state="changeState"
                @dso_zone="changeDSOZone"
                @year="changeYear"
                :country="country"
              />
              <!-- <Filters
                :map="maps"
                @addAssetMarkers="addAssetMarkers"
                @change="changeLayer"
                @wind="changeWind"
                @load="changeLoad"
                @ev="changeEV"
                @country="changeCountry"
                @state="changeState"
                @dso_zone="changeDSOZone"
                @year="changeYear"
                :country="country"
              /> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import LandingBar from "../../components/Common/LandingBarDSO.vue";
  import Map from "./MatchingMap.vue";
  import Filters from "./MatchingFilters.vue";
  import Auto from "./MatchingAutoDSONew.vue";
  import AssetDataService from "../../services/AssetDataService";
  import OfferDataService from "../../services/OfferDataService";
  import RequestDataService from "../../services/RequestDataService";
  //import UserService from "../../services/user.service";
  import mapboxgl from "mapbox-gl";
  import "mapbox-gl/dist/mapbox-gl.css";
  
  import { bulgariaOffers } from "../../maps/data";
  import { turkeyOffers } from "../../maps/data";
  //import { geojsonOffers } from "../../maps/data";
  
  //import customerMarker from "../../img/blueMarker.png";
  //import nonCustomerMarker from "../../img/redMarker.png";
  //import windMarker from "../../img/greenMarker.png";
  //import loadMarker from "../../img/greenMarker.png";
  //import evMarker from "../../img/redMarker.png";
  //import generationMarker from "../../img/blueMarker.png";
  //import { brusselsCustomers } from "../../maps/data";
  const country = require("../../maps");
  const dso_zone = require("../../maps/data");
  const data = require("../../maps/data");
  const turf = require("@turf/turf");
  const L = require("leaflet");
  
  import * as animationData from "../../assets/energyLottie.json";
  
  //const bulgaria = require("../maps/bulgaria");
  //const romania = require("../maps/romania");
  //import Supercluster from "supercluster";
  export default {
    name: "home",
    props: ["offers"],
    x: 0,
    components: {
      Filters,
      Map,
      Auto,
      LandingBar,
    },
    data() {
      return {
        content: "",
  
        accessToken:
          "pk.eyJ1IjoiamFycm9keWVsbGV0cyIsImEiOiJjazZieHI5NXEwNGUwM2ptc3F4ejZ6MmJ5In0.5zZ0n1qoedqjHeuNllLYPw", // your access token. Needed if you using Mapbox maps
        mapStyle: "mapbox://styles/jarrodyellets/ck6byoqcp4k5e1is4565r4vl8", // your map style
        zoom: country.bulgaria.zoom,
        defaultOptions: { animationData: animationData.default },
        maps: "",
        country: country.bulgaria,
        countryCode: "BG",
        dso_zone: "",
        coordinates: country.bulgaria.coordinates,
        windCord: [],
        currentMatching: null,
        currentIndex: -1,
        windRadius: 5,
        firstSymbolID: [],
        assets: [],
        featureLength: 0,
        offer: [],
        requests: [],
  
        allMatchings: [
          {
            id: 1,
            requestCode: "BUCEZ00220200801",
            offerCode: "BUCEZ00220200111",
            when: "Weekdays",
            locationName: "Vidin",
            dateFrom: "2021/09/05",
            dateTo: "2021/09/10",
            timeFrom: "09:00",
            timeTo: "13:00",
            volume: "25",
            price: "85",
            totalPrice: "1500",
          },
          {
            id: 2,
            requestCode: "BUCEZ00220200802",
            offerCode: "BUCEZ00220200102",
            when: "All days",
            locationName: "Montana",
            dateFrom: "2021/09/01",
            dateTo: "2021/09/25",
            timeFrom: "11:00",
            timeTo: "23:00",
            volume: "50",
            price: "100",
            totalPrice: "8500",
          },
          {
            id: 3,
            requestCode: "BUCEZ00220200803",
            offerCode: "BUCEZ00220200321",
            when: "Weekends",
            locationName: "Vratsa",
            dateFrom: "2021/10/03",
            dateTo: "2021/10/21",
            timeFrom: "12:00",
            timeTo: "21:00",
            volume: "65",
            price: "60",
            totalPrice: "3500",
          },
          {
            id: 4,
            requestCode: "BUCEZ00220200804",
            offerCode: "BUCEZ00220200107",
            when: "Weekends",
            locationName: "Pleven",
            dateFrom: "2021/09/10",
            dateTo: "2021/10/21",
            timeFrom: "14:00",
            timeTo: "20:00",
            volume: "35",
            price: "70",
            totalPrice: "5500",
          },
          {
            id: 5,
            requestCode: "BUCEZ00220200805",
            offerCode: "BUCEZ00220200009",
            when: "Weekdays",
            locationName: "Lovech",
            dateFrom: "2021/09/15",
            dateTo: "2021/10/01",
            timeFrom: "06:00",
            timeTo: "12:00",
            volume: "25",
            price: "40",
            totalPrice: "2500",
          },
          {
            id: 6,
            requestCode: "BUCEZ00220200806",
            offerCode: "BUCEZ00220200201",
            when: "Weekdays",
            locationName: "Sofia-City",
            dateFrom: "2021/09/01",
            dateTo: "2021/11/01",
            timeFrom: "03:00",
            timeTo: "22:00",
            volume: "75",
            price: "90",
            totalPrice: "9500",
          },
          {
            id: 7,
            requestCode: "BUCEZ00220200807",
            offerCode: "BUCEZ00220200223",
            when: "Weekends",
            locationName: "Kyustendil",
            dateFrom: "2021/09/02",
            dateTo: "2021/09/05",
            timeFrom: "03:00",
            timeTo: "23:00",
            volume: "70",
            price: "40",
            totalPrice: "3000",
          },
          {
            id: 8,
            requestCode: "BUCEZ00220200808",
            offerCode: "BUCEZ00220200224",
            when: "Weekends",
            locationName: "Blagoevgrad",
            dateFrom: "2021/09/01",
            dateTo: "2021/09/10",
            timeFrom: "07:00",
            timeTo: "20:00",
            volume: "30",
            price: "50",
            totalPrice: "5000",
          },
          {
            id: 9,
            requestCode: "BUCEZ00220200809",
            offerCode: "BUCEZ00220200225",
            when: "Weekdays",
            locationName: "Pernik",
            dateFrom: "2021/09/20",
            dateTo: "2021/09/30",
            timeFrom: "09:00",
            timeTo: "18:00",
            volume: "35",
            price: "30",
            totalPrice: "2300",
          },
          {
            id: 10,
            requestCode: "BUCEZ00220200810",
            offerCode: "BUCEZ00220200226",
            when: "Weekdays",
            locationName: "Sofia",
            dateFrom: "2021/09/15",
            dateTo: "2021/10/05",
            timeFrom: "12:00",
            timeTo: "14:00",
            volume: "15",
            price: "50",
            totalPrice: "3600",
          },
        ],
        countryCodes: {
          Bulgaria: "BG",
          Turkey: "TR",
        },
  
        offersMap:  {
          /* "type": "FeatureCollection",
          "crs": { 
              "type": "name", "properties": { 
                  "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } 
          },
          "features":[] */
          "type":"FeatureCollection",
          "features":[
            
          ]
        },
  
      };
    },
    
    methods: {
  
      offerRequest(){
        this.Apps.offerRequest();
      },
      setCurrentMatching(match) {
        this.currentMatching = match;
      },
      goToBuy() {
       /* this.$router.push({
          name: "buypart1Admin",
          params: { match: this.currentMatching },
        });*/
        this.Apps.offerManualMatching();
      },
      setCurrentIndex(index) {
        this.currentIndex = index;
      },
      filterOffersRequests(filter, bol) {
        console.log(filter, bol);
        if (bol) {
          let markers = document.querySelectorAll("." + filter);
          for (let marker of markers) {
            if (marker.classList.contains(this.countryCode)) {
              marker.classList.remove("hide");
            }
          }
        } else if (!bol) {
          let markers = document.querySelectorAll("." + filter);
          for (let marker of markers) {
            marker.classList.add("hide");
          }
        }
      },
  
      retrieveOffers() {
        if (this.$store.state.auth.user.roles == "ROLE_ADMIN" &&
            this.$store.state.auth.user.countryCode == "BE") 
        {
          OfferDataService.getAll()
            .then((response) => {
              console.log("HERE... retrieve offers sucessfull: ", this.offers);
                var longitude = null;
                var latitude = null;
  
                for (var i = 0; i < this.offers.length; i++) {
                  longitude = parseFloat(this.assets.filter(x => x.assetName === this.offers[i].assetCode)[0].assetLong);
                  latitude = parseFloat(this.assets.filter(x => x.assetName === this.offers[i].assetCode)[0].assetLat);
  
                  this.offersMap.features.push({
                    "type": "Feature", 
                    "properties": this.offers[i], 
                    "geometry": {
                      "type": "Point",
                      "coordinates": [longitude, latitude, 0.0]
                    },
                  }) 
                }
                this.offersMap = JSON.stringify(this.offersMap);
                console.log("CHECK... offersMap: ", this.offersMap);
  
              })
              .catch((e) => {
                console.log("HERE... error: " + e);
              });
        } else {
          OfferDataService.findByCountryCode(this.$store.state.auth.user.countryCode)
            .then((response) => {
                this.offers = response.data;
                console.log("HERE... retrieve offers sucessfull: ", this.offers);
                var longitude = null;
                var latitude = null;
  
                for (var i = 0; i < this.offers.length; i++) {
                  longitude = parseFloat(this.assets.filter(x => x.assetName === this.offers[i].assetCode)[0].assetLong);
                  latitude = parseFloat(this.assets.filter(x => x.assetName === this.offers[i].assetCode)[0].assetLat);
  
                  this.offersMap.features.push({
                    "type": "Feature", 
                    "properties": this.offers[i], 
                    "geometry": {
                      "type": "Point",
                      "coordinates": [longitude, latitude, 0.0]
                    },
                  }) 
                }
                this.offersMap = JSON.stringify(this.offersMap);
  
              })
              .catch((e) => {
                console.log("HERE... error: " + e);
              });
        }
      },
  
      retrieveRequests() {
        if (this.$store.state.auth.user.roles == "ROLE_ADMIN" &&
            this.$store.state.auth.user.countryCode == "BE") 
        {
          RequestDataService.getAll()
            .then((response) => {
              this.requests = response.data;
              console.log("RRRRRRRR", this.requests);
            })
            .catch((e) => {
              console.log("HERE... error: " + e);
            });
        } else {
          RequestDataService.findByCountryCode(this.$store.state.auth.user.countryCode)
            .then((response) => {
                this.requests = response.data;
                console.log("BBBBb", this.requests);
              })
              .catch((e) => {
                console.log("HERE... error: " + e);
              });
        }
      },
  
      async retrieveAssets() {
        await this.retrieveOffers();
        await this.retrieveRequests();
        //await AssetDataService.getAll()
        await AssetDataService.findByCountryCode(
          this.$store.state.auth.user.countryCode
        )
          .then((response) => {
            this.assets = response.data;
            //   this.addAssetMarkers()
            //this.buildMap("BG");
            this.buildMap(this.$store.state.auth.user.countryCode);
          })
          .catch((e) => {
            console.log("HERE... retrieve assets error: " + e);
          });
      },
      zoomToState(state) {
        let map = this.maps;
        if (state !== "all") {
          let index = this.$data.country.features.findIndex(
            // let index = this.$data.country.DSOs[0].features.findIndex(
            (x) => x.properties.code === state
          );
          let coordinates =
            this.$data.country.features[index].geometry.coordinates;
          // let coordinates = this.$data.country.DSOs[0].features[index].geometry.coordinates;
          var fit = new L.Polygon(coordinates).getBounds();
          console.log("YOOOOOOOOOOOOOOOOOOO", this.$data.country.features[index]);
          var southWest = new mapboxgl.LngLat(
            fit["_southWest"]["lat"],
            fit["_southWest"]["lng"]
          );
          let northEast = new mapboxgl.LngLat(
            fit["_northEast"]["lat"],
            fit["_northEast"]["lng"]
          );
          // let center = new mapboxgl.LngLatBounds(
          //   southWest,
          //   northEast
          // ).getCenter();
          map.fitBounds(new mapboxgl.LngLatBounds(southWest, northEast));
        } else {
          map.flyTo({
            center: this.$data.country.coordinates,
            essential: true,
            zoom: this.$data.country.zoom,
          });
        }
      },
      zoomToPoint(point) {
        let map = this.maps;
        console.log(point);
        //let marker = bulgariaOffers.features.find(
        let marker = turkeyOffers.features.find(
          ({ properties }) => properties.id === point
        );
        map.flyTo({
          center: marker.geometry.coordinates,
          essential: true,
          zoom: 9,
        });
      },
      changeStateColor(state) {
        let index;
        let map = this.maps;
        this.clearMap();
        map.removeSource("state");
        if (state !== "all") {
          index = this.$data.country.features.findIndex(
            // let index = this.$data.country.DSOs[0].features.findIndex(
            (x) => x.properties.code === state
          );
        }
        map.addSource("state", {
          type: "geojson",
          data: this.$data.country.features[index],
        });
        map.addLayer({
          id: "state-borders",
          type: "line",
          source: "state",
          layout: {},
          paint: {
            "line-color": "#5656d6",
            "line-width": [
              "case",
              ["boolean", ["feature-state", "hover"], false],
              2,
              2,
            ],
          },
        });
        if (index % 3 == 0) {
          map.addLayer({
            id: "state-fills",
            type: "fill",
            source: "state",
            layout: {},
            paint: {
              "fill-color": "#FF0000",
              "fill-opacity": [
                "case",
                ["boolean", ["feature-state", "hover"], false],
                1,
                0.5,
              ],
            },
          });
        } else if (index % 2 == 0) {
          map.addLayer({
            id: "state-fills",
            type: "fill",
            source: "state",
            layout: {},
            paint: {
              "fill-color": "#FFCC00",
              "fill-opacity": [
                "case",
                ["boolean", ["feature-state", "hover"], false],
                1,
                0.5,
              ],
            },
          });
        } else {
          map.addLayer({
            id: "state-fills",
            type: "fill",
            source: "state",
            layout: {},
            paint: {
              "fill-color": "#90EE90",
              "fill-opacity": [
                "case",
                ["boolean", ["feature-state", "hover"], false],
                1,
                0.5,
              ],
            },
          });
          map.addLayer({
            id: "state-borders",
            type: "line",
            source: "state",
            layout: {},
            paint: {
              "line-color": "#5656d6",
              "line-width": [
                "case",
                ["boolean", ["feature-state", "hover"], false],
                2,
                1,
              ],
            },
          });
        }
      },
      setCurrentPoint(id) {
        console.log("YUPPPPPP", id);
      },
      changeLoad(layer) {
        let map = this.maps;
        let visibility = map.getLayoutProperty(layer, "visibility");
        if (visibility === "visible") {
          map.setLayoutProperty(layer, "visibility", "none");
          this.className = "";
        } else {
          this.className = "active";
          map.setLayoutProperty(layer, "visibility", "visible");
        }
      },
      changeEV(layer) {
        let map = this.maps;
        let visibility = map.getLayoutProperty(layer, "visibility");
        if (visibility === "visible") {
          map.setLayoutProperty(layer, "visibility", "none");
          this.className = "";
        } else {
          this.className = "active";
          map.setLayoutProperty(layer, "visibility", "visible");
        }
      },
      changeLayer(layer) {
        let map = this.maps;
        map.setLayoutProperty(layer, "visibility", "visible");
        let markers = document.querySelectorAll("." + layer);
        for (let marker of markers) {
          if (marker.classList.contains("hide")) {
            marker.classList.remove("hide");
          } else {
            marker.classList.add("hide");
          }
        }
      },
      changeState(state) {
        console.log("state", state);
        if (state === "region") {
          let markers = document.querySelectorAll("." + this.countryCode);
          for (let marker of markers) {
            marker.classList.remove("hide");
          }
          this.zoomToState("all");
          return true;
        }
        this.zoomToState(state);
        // this.changeStateColor(state);
        let index = this.$data.country.features.findIndex(
          (x) => x.properties.code === state
        );
        let markers = document.querySelectorAll("." + this.countryCode);
        for (let marker of markers) {
          marker.classList.add("hide");
          let id = marker.id;
          let cords;
          for (let asset of this.assets) {
            if (id === asset.assetCode) {
              let long = Number(asset.assetLong.replace(",", "."));
              let lat = Number(asset.assetLat.replace(",", "."));
              cords = turf.point([long, lat]);
              break;
            }
          }
          if (cords) {
            if (
              turf.booleanPointInPolygon(
                cords,
                this.$data.country.features[index]
              )
            ) {
              marker.classList.remove("hide");
            }
          }
        }
      },
      onInput(event, id) {
        this.$data.windRadius = event.target.value;
        //
        this.id = id;
      },
      onSubmit(e, id, popup) {
        let map = this.maps;
        let radius = this.$data.windRadius;
        let cord = this.$data.windCord;
        popup.remove();
        map.removeLayer("range" + id);
        map.removeSource("range" + id);
        let markers = document.querySelectorAll(".energyMarker" + id);
        for (let marker of markers) {
          marker.classList.remove("activeMarker", "energyMarker" + id);
        }
        map.addLayer({
          id: "range" + id,
          type: "fill",
          source: {
            type: "geojson",
            data: this.showWindRange(cord, radius),
          },
          paint: {
            "fill-color": "#24a1b7",
            "fill-opacity": 0.2,
          },
        });
        this.findNearByCustomers(this.showWindRange(cord, radius), "add");
      },
      drawRange(e, color) {
        let id = e.id;
        let map = this.maps;
        let radius = e.data.capacity;
        let range = this.showWindRange(e.geometry.coordinates, radius);
        if (!map.getLayer("range" + id)) {
          map.addLayer({
            id: "range" + id,
            type: "fill",
            source: {
              type: "geojson",
              data: this.showWindRange(e.geometry.coordinates, radius),
            },
            paint: {
              "fill-color": color,
              "fill-opacity": 0.2,
            },
          });
          this.findNearByCustomers(range, "add", id);
        } else {
          this.findNearByCustomers(
            map.getSource("range" + id)._data,
            "remove",
            id
          );
          map.removeLayer("range" + id);
          map.removeSource("range" + id);
        }
      },
      showWindRange(center, radius) {
        let options = {
          steps: 10,
          units: "kilometers",
        };
        return turf.circle(center, radius, options);
      },
      findNearByCustomers(poly, action, id) {
        //let map = this.maps;
        for (let point of data.customers.features) {
          if (turf.booleanPointInPolygon(point.geometry.coordinates, poly)) {
            if (action === "add") {
              let marker = document.getElementById(
                point.geometry.coordinates[0] + point.geometry.coordinates[1]
              );
              marker.classList.add("activeMarker", "energyMarker" + id);
            } else {
              let marker = document.getElementById(
                point.geometry.coordinates[0] + point.geometry.coordinates[1]
              );
              marker.classList.remove("activeMarker", "energyMarker" + id);
              if (
                [].some.call(marker.classList, (c) => /energyMarker.*/.test(c))
              ) {
                marker.classList.add("activeMarker");
              }
            }
          }
        }
      },
      async changeCountry(target) {
        this.clearMap();
        this.x = 200;
        let map = this.maps;
        let layers = map.getStyle().layers;
        for (var j = 0; j < layers.length; j++) {
          if (layers[j].id === "settlement-subdivision-label") {
            this.firstSymbolID = layers[j].id;
            break;
          }
        }
        this.$data.countryCode = target;
        this.$data.country = await country[target];
        map.removeLayer("state-borders");
        map.removeLayer("state-fills");
        map.removeSource("states");
        map.addSource("states", {
          type: "geojson",
          data: country[target],
        });
        map.addLayer({
          id: "state-borders",
          type: "line",
          source: "states",
          layout: {},
          paint: {
            "line-color": "#5656d6",
            "line-width": [
              "case",
              ["boolean", ["feature-state", "hover"], false],
              2,
              1,
            ],
          },
        });
        this.$data.country = country[target];
        await map.flyTo({
          center: country[target].coordinates,
          essential: true,
          zoom: country[target].zoom,
        });
        // building map for this country
        if (Object.keys(country[target].features).length < this.x) {
          this.x = Object.keys(country[target].features).length;
        }
        for (var i = 0; i < this.x; i++) {
          // map.removeLayer("state-borders"+i);
          // map.removeLayer("state-fills"+i);
          // map.removeSource("states"+i);
          if (i % 3 == 0) {
            map.addSource("states" + i, {
              type: "geojson",
              data: country[target].features[i],
            });
            map.addLayer(
              {
                id: "state-fills" + i,
                type: "fill",
                source: "states" + i,
                layout: {},
                paint: {
                  "fill-color": "#FF0000",
                  "fill-opacity": [
                    "case",
                    ["boolean", ["feature-state", "hover"], false],
                    1,
                    0.5,
                  ],
                },
              },
              this.firstSymbolID
            );
          } else if (i % 2 == 0) {
            map.addSource("states" + i, {
              type: "geojson",
              data: country[target].features[i],
            });
            map.addLayer(
              {
                id: "state-fills" + i,
                type: "fill",
                source: "states" + i,
                layout: {},
                paint: {
                  "fill-color": "#FFCC00",
                  "fill-opacity": [
                    "case",
                    ["boolean", ["feature-state", "hover"], false],
                    1,
                    0.5,
                  ],
                },
              },
              this.firstSymbolID
            );
          } else {
            map.addSource("states" + i, {
              type: "geojson",
              data: country[target].features[i],
            });
            map.addLayer(
              {
                id: "state-fills" + i,
                type: "fill",
                source: "states" + i,
                layout: {},
                paint: {
                  "fill-color": "#90EE90",
                  "fill-opacity": [
                    "case",
                    ["boolean", ["feature-state", "hover"], false],
                    1,
                    0.5,
                  ],
                },
              },
              this.firstSymbolID
            );
          }
        }
        this.showMarkers();
        // this.setXValue(this.x);
        this.dso_zone.name = null;
      },
      filterRequests(bol) {
        let map = this.maps;
        this.x = this.country.features.length;
        if (!bol) {
          for (var k = 0; k < this.x; k++) {
            map.setLayoutProperty("state-fills" + k, "visibility", "none");
          }
        } else if (bol) {
          for (var i = 0; i < this.x; ++i) {
            map.setLayoutProperty("state-fills" + i, "visibility", "visible");
          }
        }
      },
      async clearMap() {
        let map = this.maps;
        this.x = 200;
        for (var i = 0; i < this.x; i++) {
          map.removeLayer("state-fills" + i);
          map.removeLayer("state-borders" + i);
          map.removeSource("states" + i);
        }
      },
      async changeDSOZone(target) {
        if (target === "dso-zone") {
          this.changeCountry(this.countryCode);
        }
        this.clearMap();
        this.x = 200;
        let map = this.maps;
        this.$data.dso_zone = await dso_zone[target];
        map.removeLayer("state-borders");
        map.removeLayer("state-fills");
        map.removeSource("states");
        map.addSource("states", {
          type: "geojson",
          data: dso_zone[target],
        });
        map.addLayer({
          id: "state-borders",
          type: "line",
          source: "states",
          layout: {},
          paint: {
            "line-color": "#5656d6",
            "line-width": [
              "case",
              ["boolean", ["feature-state", "hover"], false],
              2,
              2,
            ],
          },
        });
        if (Object.keys(dso_zone[target].features).length < this.x) {
          this.x = Object.keys(dso_zone[target].features).length;
        }
        for (var i = 0; i < this.x; i++) {
          // map.removeLayer("state-borders"+i);
          // map.removeLayer("state-fills"+i);
          // map.removeSource("states"+i);
          if (i % 3 == 0) {
            map.addSource("states" + i, {
              type: "geojson",
              data: dso_zone[target].features[i],
            });
            /* 
            map.addLayer({
              id: "state-fills" + i,
              type: "fill",
              source: "states" + i,
              layout: {},
              paint: {
                "fill-color": "#FF0000",
                "fill-opacity": [
                  "case",
                  ["boolean", ["feature-state", "hover"], false],
                  1,
                  0.5,
                ],
              },
            });
           */
            map.addLayer({
              id: "state-borders" + i,
              type: "line",
              source: "states" + i,
              layout: {},
              paint: {
                "line-color": "#5656d6",
                "line-width": [
                  "case",
                  ["boolean", ["feature-state", "hover"], false],
                  2,
                  1,
                ],
              },
            });
          } else if (i % 2 == 0) {
            map.addSource("states" + i, {
              type: "geojson",
              data: dso_zone[target].features[i],
            });
            /* 
            map.addLayer({
              id: "state-fills" + i,
              type: "fill",
              source: "states" + i,
              layout: {},
              paint: {
                "fill-color": "#FFCC00",
                "fill-opacity": [
                  "case",
                  ["boolean", ["feature-state", "hover"], false],
                  1,
                  0.5,
                ],
              },
            });
           */
            map.addLayer({
              id: "state-borders" + i,
              type: "line",
              source: "states" + i,
              layout: {},
              paint: {
                "line-color": "#5656d6",
                "line-width": [
                  "case",
                  ["boolean", ["feature-state", "hover"], false],
                  2,
                  1,
                ],
              },
            });
          } else {
            map.addSource("states" + i, {
              type: "geojson",
              data: dso_zone[target].features[i],
            });
            /* 
            map.addLayer({
              id: "state-fills" + i,
              type: "fill",
              source: "states" + i,
              layout: {},
              paint: {
                "fill-color": "#90EE90",
                "fill-opacity": [
                  "case",
                  ["boolean", ["feature-state", "hover"], false],
                  1,
                  0.5,
                ],
              },
            });
           */
            map.addLayer({
              id: "state-borders" + i,
              type: "line",
              source: "states" + i,
              layout: {},
              paint: {
                "line-color": "#5656d6",
                "line-width": [
                  "case",
                  ["boolean", ["feature-state", "hover"], false],
                  2,
                  1,
                ],
              },
            });
          }
        }
        this.$data.dso_zone = dso_zone[target];
        let markers = document.querySelectorAll("." + this.countryCode);
        for (let marker of markers) {
          marker.classList.add("hide");
          let id = marker.id;
          let cords;
          for (let asset of this.assets) {
            if (id === asset.assetCode) {
              let long = Number(asset.assetLong.replace(",", "."));
              let lat = Number(asset.assetLat.replace(",", "."));
              cords = turf.point([long, lat]);
              break;
            }
          }
          if (cords) {
            for (let feature of this.$data.dso_zone.features) {
              if (turf.booleanPointInPolygon(cords, feature)) {
                marker.classList.remove("hide");
              }
            }
          }
        }
        await map.flyTo({
          //center: dso_zone[target].features[0].geometry.coordinates,
          center: dso_zone[target].features.geometry.coordinates,
          essential: true,
          zoom: dso_zone[target].zoom,
          /* center: dso_zone[target].coordinates,
          essential: true,
          zoom: dso_zone[target].zoom, */
        });
        map.removeLayer("state-fills");
        // map.removeSource("states");
      },
  
      /* async changeYear(target) {
        var y_target = "y_" + target;
        let map = this.maps;
        let firstSymbolID = this.firstSymbolID;
        map.removeLayer("state-borders");
        map.removeLayer("state-fills");
        //map.removeSource("states");
        for (
          var i = 0;
          i < Object.keys(dso_zone[y_target].features).length;
          i++
        ) {
          map.removeLayer("state-borders" + i);
          map.removeLayer("state-fills" + i);
          map.removeSource("states" + i);
          if (dso_zone[y_target].features[i].properties.status == "C") {
            map.addSource("states" + i, {
              type: "geojson",
              data: dso_zone[y_target].features[i],
            });
            map.addLayer(
              {
                id: "state-fills" + i,
                type: "fill",
                source: "states" + i,
                layout: {},
                paint: {
                  "fill-color": "#FF0000",
                  "fill-opacity": [
                    "case",
                    ["boolean", ["feature-state", "hover"], false],
                    1,
                    0.5,
                  ],
                },
              },
              firstSymbolID
            );
            map.addLayer(
              {
                id: "state-borders" + i,
                type: "line",
                source: "states" + i,
                layout: {},
                paint: {
                  "line-color": "#5656d6",
                  "line-width": [
                    "case",
                    ["boolean", ["feature-state", "hover"], false],
                    2,
                    1,
                  ],
                },
              },
              firstSymbolID
            );
          } else if (dso_zone[y_target].features[i].properties.status == "B") {
            map.addSource("states" + i, {
              type: "geojson",
              data: dso_zone[y_target].features[i],
            });
            map.addLayer(
              {
                id: "state-fills" + i,
                type: "fill",
                source: "states" + i,
                layout: {},
                paint: {
                  "fill-color": "#FFCC00",
                  "fill-opacity": [
                    "case",
                    ["boolean", ["feature-state", "hover"], false],
                    1,
                    0.5,
                  ],
                },
              },
              firstSymbolID
            );
            map.addLayer(
              {
                id: "state-borders" + i,
                type: "line",
                source: "states" + i,
                layout: {},
                paint: {
                  "line-color": "#5656d6",
                  "line-width": [
                    "case",
                    ["boolean", ["feature-state", "hover"], false],
                    2,
                    1,
                  ],
                },
              },
              firstSymbolID
            );
          } else {
            map.addSource("states" + i, {
              type: "geojson",
              data: dso_zone[y_target].features[i],
            });
            map.addLayer(
              {
                id: "state-fills" + i,
                type: "fill",
                source: "states" + i,
                layout: {},
                paint: {
                  "fill-color": "#90EE90",
                  "fill-opacity": [
                    "case",
                    ["boolean", ["feature-state", "hover"], false],
                    1,
                    0.5,
                  ],
                },
              },
              firstSymbolID
            );
            map.addLayer(
              {
                id: "state-borders" + i,
                type: "line",
                source: "states" + i,
                layout: {},
                paint: {
                  "line-color": "#5656d6",
                  "line-width": [
                    "case",
                    ["boolean", ["feature-state", "hover"], false],
                    2,
                    1,
                  ],
                },
              },
              firstSymbolID
            );
          }
        }
      }, */
  
      async changeYear(target) {
        //var y_target = "y_" + target;
        console.log("HERE... target: " + target);
        console.log("HERE... country: " + this.country.id);
        console.log("HERE... length: " + this.country.features.length);
        console.log("HERE... DSO: " + this.dso_zone.name);
        let map = this.maps;
        let firstSymbolID = this.firstSymbolID;
        map.removeLayer("state-borders");
        map.removeLayer("state-fills");
        //map.removeSource("states");
        if (this.dso_zone.name == null) {
          for (
            var i = 0;
            //i < Object.keys(dso_zone[y_target].features).length;
            i < Object.keys(this.country.features).length;
            i++
          ) {
            map.removeLayer("state-borders" + i);
            map.removeLayer("state-fills" + i);
            map.removeSource("states" + i);
            var iTarget = parseInt(i) + parseInt(target);
            //if (dso_zone[y_target].features[i].properties.status == "C") {
            if (iTarget % 2 == 0) {
              map.addSource("states" + i, {
                type: "geojson",
                //data: dso_zone[y_target].features[i],
                data: this.country.features[i],
              });
              map.addLayer(
                {
                  id: "state-fills" + i,
                  type: "fill",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "fill-color": "#FF0000",
                    "fill-opacity": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      1,
                      0.5,
                    ],
                  },
                },
                firstSymbolID
              );
              map.addLayer(
                {
                  id: "state-borders" + i,
                  type: "line",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "line-color": "#5656d6",
                    "line-width": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      2,
                      1,
                    ],
                  },
                },
                firstSymbolID
              );
            }
            //else if (dso_zone[y_target].features[i].properties.status == "B") {
            else if (iTarget % 3 == 0) {
              map.addSource("states" + i, {
                type: "geojson",
                //data: dso_zone[y_target].features[i],
                data: this.country.features[i],
              });
              map.addLayer(
                {
                  id: "state-fills" + i,
                  type: "fill",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "fill-color": "#FFCC00",
                    "fill-opacity": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      1,
                      0.5,
                    ],
                  },
                },
                firstSymbolID
              );
              map.addLayer(
                {
                  id: "state-borders" + i,
                  type: "line",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "line-color": "#5656d6",
                    "line-width": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      2,
                      1,
                    ],
                  },
                },
                firstSymbolID
              );
            } else {
              map.addSource("states" + i, {
                type: "geojson",
                //data: dso_zone[y_target].features[i],
                data: this.country.features[i],
              });
              map.addLayer(
                {
                  id: "state-fills" + i,
                  type: "fill",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "fill-color": "#90EE90",
                    "fill-opacity": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      1,
                      0.5,
                    ],
                  },
                },
                firstSymbolID
              );
              map.addLayer(
                {
                  id: "state-borders" + i,
                  type: "line",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "line-color": "#5656d6",
                    "line-width": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      2,
                      1,
                    ],
                  },
                },
                firstSymbolID
              );
            }
          }
        } else {
          for (
            var i = 0;
            //i < Object.keys(dso_zone[y_target].features).length;
            i < Object.keys(this.dso_zone.features).length;
            i++
          ) {
            map.removeLayer("state-borders" + i);
            map.removeLayer("state-fills" + i);
            map.removeSource("states" + i);
            var iTarget = parseInt(i) + parseInt(target);
            //if (dso_zone[y_target].features[i].properties.status == "C") {
            if (iTarget % 2 == 0) {
              map.addSource("states" + i, {
                type: "geojson",
                //data: dso_zone[y_target].features[i],
                data: this.dso_zone.features[i],
              });
              map.addLayer(
                {
                  id: "state-fills" + i,
                  type: "fill",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "fill-color": "#FF0000",
                    "fill-opacity": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      1,
                      0.5,
                    ],
                  },
                },
                firstSymbolID
              );
              map.addLayer(
                {
                  id: "state-borders" + i,
                  type: "line",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "line-color": "#5656d6",
                    "line-width": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      2,
                      1,
                    ],
                  },
                },
                firstSymbolID
              );
            }
            //else if (dso_zone[y_target].features[i].properties.status == "B") {
            else if (iTarget % 3 == 0) {
              map.addSource("states" + i, {
                type: "geojson",
                //data: dso_zone[y_target].features[i],
                data: this.dso_zone.features[i],
              });
              map.addLayer(
                {
                  id: "state-fills" + i,
                  type: "fill",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "fill-color": "#FFCC00",
                    "fill-opacity": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      1,
                      0.5,
                    ],
                  },
                },
                firstSymbolID
              );
              map.addLayer(
                {
                  id: "state-borders" + i,
                  type: "line",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "line-color": "#5656d6",
                    "line-width": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      2,
                      1,
                    ],
                  },
                },
                firstSymbolID
              );
            } else {
              map.addSource("states" + i, {
                type: "geojson",
                //data: dso_zone[y_target].features[i],
                data: this.dso_zone.features[i],
              });
              map.addLayer(
                {
                  id: "state-fills" + i,
                  type: "fill",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "fill-color": "#90EE90",
                    "fill-opacity": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      1,
                      0.5,
                    ],
                  },
                },
                firstSymbolID
              );
              map.addLayer(
                {
                  id: "state-borders" + i,
                  type: "line",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "line-color": "#5656d6",
                    "line-width": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      2,
                      1,
                    ],
                  },
                },
                firstSymbolID
              );
            }
          }
        }
      },
  
      showMarkers() {
        let that = this;
        let markers = document.querySelectorAll(".marker");
        for (let m of markers) {
          m.classList.remove("hide");
          if (!m.classList.contains(that.countryCode)) {
            m.classList.add("hide");
          }
        }
      },
      map: function () {
        mapboxgl.accessToken = this.accessToken;
        return new mapboxgl.Map({
          container: "map",
          style: this.mapStyle,
          center: this.coordinates,
          zoom: this.zoom,
        });
      },
      buildMap(target) {
        //let hoveredStateId = null;
        let map = this.map();
        var x = 0;
        //let country = this.country;
        this.featureLength = this.country.features.length;
        let that = this;
        map.addControl(new mapboxgl.NavigationControl());
        map.on("load", function () {
          map.resize();
          map.addSource("states", {
            type: "geojson",
            data: country[target],
            // data: getXValue()
            // data: dso_zone.y_2020
          });
          let layers = map.getStyle().layers;
          for (var j = 0; j < layers.length; j++) {
            if (layers[j].id === "settlement-subdivision-label") {
              that.firstSymbolID = layers[j].id;
              break;
            }
          }
          //console.log("HERE... the number of regions: "+ Object.keys(country.BE.features).length);
          if (Object.keys(country[target].features).length > x) {
            x = Object.keys(country[target].features).length;
          }
          for (var i = 0; i < x; i++) {
            if (i % 3 == 0) {
              map.addSource("states" + i, {
                type: "geojson",
                data: country[target].features[i],
              });
  
              /*             
              map.addLayer(
                {
                  id: "state-fills" + i,
                  type: "fill",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "fill-color": "#FF0000",
                    "fill-opacity": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      1,
                      0.5,
                    ],
                  },
                },
                that.firstSymbolID
              );
            */
  
              map.addLayer(
                {
                  id: "state-borders" + i,
                  type: "line",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "line-color": "#5656d6",
                    "line-width": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      3,
                      2,
                    ],
                  },
                },
                that.firstSymbolID
              );
            } else if (i % 2 == 0) {
              map.addSource("states" + i, {
                type: "geojson",
                data: country[target].features[i],
              });
  
              /* 
              map.addLayer(
                {
                  id: "state-fills" + i,
                  type: "fill",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "fill-color": "#FFCC00",
                    "fill-opacity": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      1,
                      0.5,
                    ],
                  },
                },
                that.firstSymbolID
              );
            */
  
              map.addLayer(
                {
                  id: "state-borders" + i,
                  type: "line",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "line-color": "#5656d6",
                    "line-width": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      3,
                      2,
                    ],
                  },
                },
                that.firstSymbolID
              );
            } else {
              map.addSource("states" + i, {
                type: "geojson",
                data: country[target].features[i],
              });
  
              /* 
              map.addLayer(
                {
                  id: "state-fills" + i,
                  type: "fill",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "fill-color": "#90EE90",
                    "fill-opacity": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      1,
                      0.5,
                    ],
                  },
                },
                that.firstSymbolID
              );
            */
  
              map.addLayer(
                {
                  id: "state-borders" + i,
                  type: "line",
                  source: "states" + i,
                  layout: {},
                  paint: {
                    "line-color": "#5656d6",
                    "line-width": [
                      "case",
                      ["boolean", ["feature-state", "hover"], false],
                      3,
                      2,
                    ],
                  },
                },
                that.firstSymbolID
              );
            }
          }
  
          
       
          // Add a new source from our GeoJSON data and
          // set the 'cluster' option to true. GL-JS will
          // add the point_count property to your source data.
  
          map.addSource("offersmap", {
            type: "geojson",
            // Point to GeoJSON data. This example visualizes all M1.0+ offersmap
            // from 12/22/15 to 1/21/16 as logged by USGS' Earthquake hazards program.
            //data: bulgariaOffers,
            data: turkeyOffers,
            //data: geojsonOffers,
            
            //data: this.offersMap,
            cluster: true,
            clusterMaxZoom: 14, // Max zoom to cluster points on
            clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
          });
  
          
  
          map.addLayer({
            id: "clusters",
            type: "circle",
            source: "offersmap",
            filter: ["has", "point_count"],
            paint: {
              // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
              // with three steps to implement three types of circles:
              //   * Blue, 20px circles when point count is less than 100
              //   * Yellow, 30px circles when point count is between 100 and 750
              //   * Pink, 40px circles when point count is greater than or equal to 750
              "circle-color": [
                "step",
                ["get", "point_count"],
                "#51bbd6",
                100,
                "#f1f075",
                750,
                "#f28cb1",
              ],
              "circle-radius": [
                "step",
                ["get", "point_count"],
                20,
                100,
                30,
                750,
                40,
              ],
            },
          });
  
          map.addLayer({
            id: "cluster-count",
            type: "symbol",
            source: "offersmap",
            filter: ["has", "point_count"],
            layout: {
              "text-field": "{point_count_abbreviated}",
              "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
              "text-size": 12,
            },
          });
  
          map.addLayer({
            id: "unclustered-point",
            type: "circle",
            source: "offersmap",
            filter: ["!", ["has", "point_count"]],
            paint: {
              "circle-color": "#11b4da",
              "circle-radius": 8,
              "circle-stroke-width": 5,
              "circle-stroke-color": "#fff",
            },
          });
  
          // inspect a cluster on click
          map.on("click", "clusters", function (e) {
            var features = map.queryRenderedFeatures(e.point, {
              layers: ["clusters"],
            });
            var clusterId = features[0].properties.cluster_id;
            map
              .getSource("offersmap")
              .getClusterExpansionZoom(clusterId, function (err, zoom) {
                if (err) return;
  
                map.easeTo({
                  center: features[0].geometry.coordinates,
                  zoom: zoom,
                });
              });
          });
  
          // When a click event occurs on a feature in
          // the unclustered-point layer, open a popup at
          // the location of the feature, with
          // description HTML from its properties.
          map.on("click", "unclustered-point", function (e) {
            var coordinates = e.features[0].geometry.coordinates.slice();
            var locationName = e.features[0].properties.locationCode;
            let id = e.features[0].properties.id;
            that.currentMatching = that.allMatchings.find(
              ({ id }) => id === e.features[0].properties.id
            );
            that.currentIndex = that.allMatchings.indexOf(that.currentMatching);
            // Ensure that if the map is zoomed out such that
            // multiple copies of the feature are visible, the
            // popup appears over the copy being pointed to.
            while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
              coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
            }
  
            new mapboxgl.Popup()
              .setLngLat(coordinates)
              .setHTML(
                //'magnitude: ' + mag + '<br>Was there a tsunami?: ' + tsunami
                `<div class='popup-info-wrapper'>
                  <div class='popup-top'>
                    <div class='popup-top-left'>
                      <div class='popup-title'> ${locationName}</div>
                      <span><i class="far fa-clock"></i> ${e.features[0].properties.dayType}</span>
                    </div>
                    <div class='popup-top-right'>
                      <div class='popup-tag'>Offers</div>
                    </div>
                  </div>
                  <div class='popup-flex'>
                    <div class='popup-left'>
                      <div class='popup-label'>Date from</div>
                      <div class='popup-info'>${e.features[0].properties.dateFrom}</div>
                      <div class='popup-label'>Time from</div>
                      <div class='popup-info'>${e.features[0].properties.timeFrom}</div>
                      <div class='popup-label'>Volume</div>
                      <div class='popup-info'>${e.features[0].properties.volume} KWh</div>
                    </div>
                    <div class='popup-right'>
                      <div class='popup-label'>Date to</div>
                      <div class='popup-info'>${e.features[0].properties.dateTo}</div>
                      <div class='popup-label'>Time to</div>
                      <div class='popup-info'>${e.features[0].properties.timeTo}</div>
                      <div class='popup-label'>Price</div>
                      <div class='popup-info'>&euro;${e.features[0].properties.price}/ KWh</div>
                      <div style="display:none" id="popup-price">${e.features[0].properties.price}</div>
                      <div style="display:none" id="popup-id">${e.features[0].properties.id}</div>
                      <div style="display:none" id="popup-volume">${e.features[0].properties.volume}</div>
                      <button class='popup-button' id='button${e.features[0].properties.id}'>Buy</button>
                    </div>
                    </div>
                  </div>`
              )
              .addTo(map);
            document
              .getElementById(`button${id}`)
              .addEventListener("click", () => {
                that.goToBuy();
              });
          });
          map.on("mouseenter", "clusters", function () {
            map.getCanvas().style.cursor = "pointer";
          });
          map.on("mouseleave", "clusters", function () {
            map.getCanvas().style.cursor = "";
          });
        });
  
        this.$data.maps = map;
      },
    },
  
    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },
      showAdminBoard() {
        if (this.currentUser && this.currentUser.roles) {
          return this.currentUser.roles.includes("ROLE_ADMIN");
        }
  
        return false;
      },
    },
  
    created() {},
  
    mounted() {
  
      this.$store.state.auth.user;
      this.countryCode = this.$store.state.auth.user.countryCode;
  
      console.log("CCCCCCC", this.countryCode);
  
      switch (this.countryCode) {
        case "AT":
          this.zoom = country.austria.zoom;
          this.country = country.austria;
          this.coordinates = country.austria.coordinates;
  
          break;
        case "BE":
          this.zoom = country.belgium.zoom;
          this.country = country.belgium;
          this.coordinates = country.belgium.coordinates;
  
          break;
  
        case "BG":
          this.zoom = country.bulgaria.zoom;
          this.country = country.bulgaria;
          this.coordinates = country.bulgaria.coordinates;
          //this.dso_zone = dso_zone.BGDSO01;
          this.dso_zone = "";
  
          break;
        case "CH":
          this.zoom = country.switzerland.zoom;
          this.country = country.switzerland;
          this.coordinates = country.switzerland.coordinates;
          //this.dso_zone = dso_zone.BGDSO01;
          this.dso_zone = "";
  
          break;
  
        case "HG":
          this.zoom = country.croatia.zoom;
          this.country = country.croatia;
          this.coordinates = country.croatia.coordinates;
  
          break;
  
        case "FR":
          this.zoom = country.france.zoom;
          this.country = country.france;
          this.coordinates = country.france.coordinates;
  
          break;
  
        case "FR":
          this.zoom = country.france.zoom;
          this.country = country.france;
          this.coordinates = country.france.coordinates;
  
          break;
  
        case "DE":
          this.zoom = country.germany.zoom;
          this.country = country.germany;
          this.coordinates = country.germany.coordinates;
  
          break;
  
        case "GR":
          this.zoom = country.greece.zoom;
          this.country = country.greece;
          this.coordinates = country.greece.coordinates;
  
          break;
  
        case "HU":
          this.zoom = country.hungary.zoom;
          this.country = country.hungary;
          this.coordinates = country.hungary.coordinates;
  
          break;
  
        case "IT":
          this.zoom = country.italy.zoom;
          this.country = country.italy;
          this.coordinates = country.italy.coordinates;
  
          break;
  
        case "LU":
          this.zoom = country.luxembourg.zoom;
          this.country = country.luxembourg;
          this.coordinates = country.luxembourg.coordinates;
  
          break;
  
        case "NL":
          this.zoom = country.netherlands.zoom;
          this.country = country.netherlands;
          this.coordinates = country.netherlands.coordinates;
  
          break;
  
        case "PL":
          this.zoom = country.poland.zoom;
          this.country = country.poland;
          this.coordinates = country.poland.coordinates;
  
          break;
  
        case "PT":
          this.zoom = country.portugal.zoom;
          this.country = country.portugal;
          this.coordinates = country.portugal.coordinates;
  
          break;
  
        case "RO":
          this.zoom = country.romania.zoom;
          this.country = country.romania;
          this.coordinates = country.romania.coordinates;
  
          break;
  
        case "SE":
          this.zoom = country.sweden.zoom;
          this.country = country.sweden;
          this.coordinates = country.sweden.coordinates;
  
          break;
  
        case "TR":
          this.zoom = country.turkey.zoom;
          this.country = country.turkey;
          this.coordinates = country.turkey.coordinates;
          //this.dso_zone = dso_zone.TRDSO16;
          this.dso_zone = "";
  
          break;
  
        default:
          this.zoom = country.belgium.zoom;
          this.country = country.belgium;
          this.coordinates = country.belgium.coordinates;
      }
  
      this.retrieveAssets();
  
      this.retrieveOffers();
  
      if (this.$store.state.auth.user.countryCode === "BG") {
        this.geojsonOffers = bulgariaOffers
      } 
      if (this.$store.state.auth.user.countryCode === "TR") { 
        this.geojsonOffers = turkeyOffers
      } 
  
      //console.log("TEST bulgariaOffers... ", bulgariaOffers);
      //console.log("TEST offersMap... ", this.offersMap);
      //console.log("TEST offersMap... ", JSON.stringify(this.offersMap));
    },
  };
  </script>
  <style lang="scss">
  @import "../../sass/main.scss";
  .dashboard {
    overflow-x: hidden;
    min-height: 100%;
    margin-top: -100px;
    margin-left: -10px;
  }
  .buy-header-wrapper {
    position: relative;
    margin: 0 auto;
    padding: 100px 0;
  }
  .buy-map-wrapper {
    height: 100%;
    display: flex;
  }
  .buy-map-inner-wrapper {
    margin: 0;
    display: flex;
    height: 100%;
    width: 100%;
  }
  .map-container {
    flex: 1;
    align-items: stretch;
    width: 100%l;
  }
  .map-right-wrapper {
    width: 95%;
    margin: 0 auto;
    position: relative;
    border: 1px solid $blue;
    align-self: stretch;
  }
  .map-right-column {
    padding: 10px;
    background: #f5fcff;
    width: 40%;
    width: 400px;
    min-height: calc(100vh - 50px);
    overflow-x: auto;
  }
  .buy-block-wrapper {
    width: 50%;
  }
  .mapboxgl-popup {
    padding-bottom: 20px;
    z-index: 1002;
  }
  .mapboxgl-popup-content {
    padding: 10px;
    padding-top: 15px;
    border-radius: 10px;
    min-width: 250px;
    background-color: rgba(255, 255, 255, 0.9);
  }
  .mapboxgl-popup-close-button {
    font-size: 16px;
  }
  .popup-info-wrapper {
    margin-bottom: 10px;
  }
  .popup-top {
    display: flex;
    justify-content: space-between;
  }
  .popup-flex {
    display: flex;
    justify-content: space-between;
  }
  .popup-left,
  .popup-right,
  .popup-top-left,
  .popup-top-right {
    width: 45%;
    position: relative;
  }
  .popup-tag {
    padding: 5px 20px;
    background-color: #253858;
    color: #fff;
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    margin-right: -10px;
  }
  .popup-title {
    font-weight: 700;
    font-size: 1.3rem;
    color: #253858;
  }
  .popup-label {
    color: #aeacad;
    font-size: 0.9rem;
    margin-top: 10px;
  }
  .popup-info {
    font-size: 0.9rem;
    color: #253858;
  }
  
  .fa-clock {
    color: #b4b2b2;
  }
  
  .popup-price {
    font-size: 1rem;
    font-weight: 700;
    color: #253858;
  }
  .popup-button {
    background-color: #58c26d;
    color: #fff;
    border: none;
    margin-top: 20px;
    padding: 8px 40px;
    border-radius: 5px;
    cursor: pointer;
  }
  .popup-button:hover {
    background-color: hsla(132, 46, 55, 0.8);
  }
  .customerMarker {
    display: block;
    border: none;
    width: 20px;
    height: 31px;
    background-image: url("../../img/blueMarker.png");
    background-size: contain;
    background-position: center;
    cursor: pointer;
    padding: 0;
    z-index: 1001;
  }
  .nonCustomerMarker {
    display: block;
    border: none;
    width: 20px;
    height: 31px;
    background-image: url("../../img/redMarker.png");
    background-size: contain;
    background-position: center;
    cursor: pointer;
    padding: 0;
    z-index: 1001;
  }
  .homeMarker {
    display: block;
    border: none;
    width: 30px;
    height: 47px;
    background-image: url("../../img/homeMarker.png");
    background-size: contain;
    background-position: center;
    cursor: pointer;
    padding: 0;
    z-index: 1001;
  }
  .loadMarker {
    display: block;
    border: none;
    width: 30px;
    height: 47px;
    background-image: url("../../img/loadMarker.png");
    background-size: contain;
    background-position: center;
    cursor: pointer;
    padding: 0;
    z-index: 1001;
  }
  .evMarker {
    display: block;
    border: none;
    width: 30px;
    height: 47px;
    background-image: url("../../img/evMarker.png");
    background-size: contain;
    background-position: center;
    cursor: pointer;
    padding: 0;
    z-index: 1001;
  }
  .generationMarker {
    display: block;
    border: none;
    width: 30px;
    height: 47px;
    background-image: url("../../img/resMarker.png");
    background-size: contain;
    background-position: center;
    cursor: pointer;
    padding: 0;
    z-index: 1001;
  }
  .windMarker {
    display: block;
    border: none;
    width: 30px;
    height: 47px;
    background-image: url("../../img/greenMarker.png");
    background-size: contain;
    background-position: center;
    cursor: pointer;
    padding: 0;
    z-index: 1001;
  }
  .solarMarker {
    display: block;
    border: none;
    width: 30px;
    height: 47px;
    background-image: url("../../img/yellowMarker.png");
    background-size: contain;
    background-position: center;
    cursor: pointer;
    padding: 0;
    z-index: 1001;
  }
  .marker {
    transition: height 1s, width 1s;
  }
  .activeMarker {
    background-image: url("../../img/blueMarker.png");
    width: 30px;
    height: 47px;
    transition: height 1s, width 1s;
  }
  .activeMarker:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    height: 5px;
    width: 15px;
    border-radius: 40%;
    background-color: rgba(0, 0, 0, 0.14);
    transition: height 1s, width 1s;
  }
  .hide {
    visibility: hidden;
  }
  
  .lottie-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
  }
  
  .loading-text {
    margin-top: 20px;
    font-size: 20px;
  }
  </style>